import axios from 'axios';
import { i18nManager } from "@/i18n/i18n";

export default {
    /**
     * 发送Post-FormData 请求
     * @param param
     * @param param.url 请求地址,从/开始 require
     * @param param.beforeSend func() 请求发送前处理函数
     * @param param.data object 请求数据
     * @param param.success func(data) 请求成功回调函数
     * @param param.error func(ret, data) 请求失败回调函数 非200状态码
     * @param param.complete func() 最终结束回调函数
     */
    postForm: (param) => {
        if (param === undefined || param.url === undefined || param.url.length <= 0) {
            console.error('请求配置不合法', param);
        }
        param.beforeSend !== undefined && typeof param.beforeSend === 'function' ? param.beforeSend() : void (0);
        axios.postForm(process.env.VUE_APP_SERVER_URL_PREFIX + param.url, param.data, {
            headers: {
                'Accept-Language': i18nManager.getAcceptLanguage(),
            }
        }).then((ret) => {
            if (ret.status === 200) {
                param.success !== undefined && typeof param.success === 'function' ? param.success(ret.data) : void (0);
            } else {
                param.error !== undefined && typeof param.error === 'function' ? param.error(ret, ret.data) : void (0);
            }
            param.complete !== undefined && typeof param.complete === 'function' ? param.complete() : void (0);
        }).catch((err) => {
            param.error !== undefined && typeof param.error === 'function' ? param.error(err, undefined) : void (0);
            param.complete !== undefined && typeof param.complete === 'function' ? param.complete() : void (0);
        });
    },
    /**
     * 获取服务器文件
     * @param param
     * @param param.url 请求地址,从/开始 require
     * @param param.beforeSend func() 请求发送前处理函数
     * @param param.success func(data) 请求成功回调函数
     * @param param.error func(ret, data) 请求失败回调函数 非200状态码
     * @param param.complete func() 最终结束回调函数
     */
    getLocalFile: (param) => {
        if (param === undefined || param.url === undefined || param.url.length <= 0) {
            console.error('请求配置不合法', param);
        }
        axios.get(param.url, {
            headers: {
                'Accept-Language': i18nManager.getAcceptLanguage(),
            }
        }).then((ret) => {
            if (ret.status === 200) {
                param.success !== undefined && typeof param.success === 'function' ? param.success(ret.data) : void (0);
            } else {
                param.error !== undefined && typeof param.error === 'function' ? param.error(ret, ret.data) : void (0);
            }
            param.complete !== undefined && typeof param.complete === 'function' ? param.complete() : void (0);
        }).catch((err) => {
            param.error !== undefined && typeof param.error === 'function' ? param.error(err, undefined) : void (0);
            param.complete !== undefined && typeof param.complete === 'function' ? param.complete() : void (0);
        });
    },
    /**
     * 发送Post-FormData 请求
     * @param url 请求地址,从/开始 require
     * @param data object 请求数据
     */
    asyncPostFrom: async (url, data) => {
        return axios.postForm(process.env.VUE_APP_SERVER_URL_PREFIX + url, data, {
            headers: {
                'Accept-Language': i18nManager.getAcceptLanguage(),
            }
        })
    }
}
